import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { commonActions } from "stores/common/commonActions"
import { chargingStationActions } from "stores/ChargingStationStore/chargingStationAction"

const mapStateToProps = (state) => {
    return {
        basicDetailData: state.chargingStation.chargingDetailList,
        isLoading : state.chargingStation.chargingStation.isLoading,
        amenitiesData: state.common.amenitiesData,
        networkData: state.common.networkData,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getBasicDetailAction: chargingStationActions.ChargingStationDetail,
  
    getAmenitiesAction: commonActions.getAmenitiesData,
    setAmenityAction: commonActions.setAmenityAction,
    getNetworkAction: commonActions.getNetworkData,
}, dispatch);

const EditStationStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default EditStationStore;